
  import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
  import { Company, User } from "@/generated/graphql";
  import MarketplaceManagerCard from "@/components/marketplace/MarketplaceManagerCard.vue";
  import MarketplaceAdminCard from "@/components/marketplace/MarketplaceAdminCard.vue";
  import Roles from "@/entities/Roles";

  @Component({
    components: {
      MarketplaceAdminCard,
      MarketplaceManagerCard,
    },
  })
  export default class MarketplaceCard extends Vue {
    @Prop({ type: Object, required: true }) readonly marketplaceUser!: User;
      @Prop({ type: Boolean, required: true }) readonly hasAllResourceAccess: boolean;
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @PropSync('nameBlockMinHeight', { type: Number, default: undefined }) nameBlockMinHeightValue?: number;
    @PropSync('skillsBlockMinHeight', { type: Number, default: undefined }) skillsBlockMinHeightValue?: number;

    get isAdmin(): boolean {
      return this.currentUser.role === Roles.ADMIN;
    }
  }
